
import { connect } from 'react-redux';

import { getOdrudaList, setFilter } from '../actions/OdrudaList';
import { getFilteredOdrudaList } from '../reducers/odrudaList';
import OdrudaListPage from '../components/OdrudaListPage';

function mapDispatchToProps() {
    return {
        getOdrudaList,
        setFilter
    };
}

function mapStateToProps(state) {
    return {
        odrudaList: state.odrudaList,
        filteredOdrudaList: getFilteredOdrudaList(state.odrudaList),
        odrudaFilter: state.odrudaList.filter
    };
}

export default connect(mapStateToProps, mapDispatchToProps())(OdrudaListPage);
